class AddOnProductManager {
  constructor() {
    // console.log('Initializing AddOnProductManager');
    this.addOnProducts = {};
    this.customOptions = {};
    this.productForm = document.querySelector('form[data-type="add-to-cart-form"]');

    this.initializeAddOnProducts();
    this.initializeCustomOptions();
    this.addEventListeners();
  }

  initializeAddOnProducts() {
    // console.log('Initializing Add-On Products');
    const checkboxes = document.querySelectorAll('.window-options input[type="checkbox"][name^="properties[Add Ons"]');
    checkboxes.forEach((checkbox) => {
      const productId = checkbox.id;
      const priceElement = checkbox.closest('.window-options').querySelector('.window-price');
      const price = priceElement ? this.parsePrice(priceElement.textContent) : 0;
      this.addOnProducts[productId] = { price, checked: checkbox.checked };
      // console.log(`Add-On Product: ${productId}, Price: ${price}, Checked: ${checkbox.checked}`);
    });
  }

  initializeCustomOptions() {
    // console.log('Initializing Custom Options');
    const optionFieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
    optionFieldsets.forEach((fieldset) => {
      const optionTitle = fieldset.querySelector('legend').textContent;
      const radioInputs = fieldset.querySelectorAll('input[type="radio"]');

      this.customOptions[optionTitle] = {
        options: Array.from(radioInputs).map((radio) => ({
          id: radio.id,
          value: radio.value,
          checked: radio.checked,
        })),
      };

      // console.log(`Custom Option Group: ${optionTitle}`);
      this.customOptions[optionTitle].options.forEach((option) => {
        // console.log(`  Option: ${option.id}, Value: ${option.value}, Checked: ${option.checked}`);
      });
    });
  }

  addEventListeners() {
    // console.log('Adding event listeners');
    this.productForm.addEventListener('submit', (event) => this.handleFormSubmit(event));
  }

  handleFormSubmit(event) {
    // console.log('Form submitted');
    event.preventDefault();

    const selectedAddOns = Object.entries(this.addOnProducts)
      .filter(([, product]) => product.checked)
      .map(([id]) => ({ id: parseInt(id.replace('note_', '')), quantity: 1 }));

    const selectedOptions = {};
    Object.entries(this.customOptions).forEach(([optionTitle, optionGroup]) => {
      const selectedOption = optionGroup.options.find((option) => option.checked);
      if (selectedOption) {
        selectedOptions[optionTitle] = selectedOption.value;
      }
    });

    const mainProductId = this.getSelectedVariantId();
    const quantityInput = this.productForm.querySelector('input[name="quantity"]');
    let mainProductQuantity = 1;

    if (quantityInput !== null) {
      mainProductQuantity = parseInt(quantityInput.value);
    } else {
      mainProductQuantity = 1;
    }

    const items = [{ id: mainProductId, quantity: mainProductQuantity, properties: selectedOptions }];

    // Add selected add-on products as separate items
    items.push(...selectedAddOns);

    // console.log('Items to be added to cart:', items);
    this.addItemsToCart(items);
  }

  async addItemsToCart(items) {
    // console.log('Adding items to cart:', items);
    // try {
    //   const response = await fetch('/cart/add.js', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ items }),
    //   });

    //   if (!response.ok) throw new Error('Failed to add items to cart');

    //   const result = await response.json();
    //   // console.log('Items added to cart:', result);
    //   window.location.href = '/cart';
    // } catch (error) {
    //   console.error('Error adding items to cart:', error);
    // }
    return
  }

  getSelectedVariantId() {
    const variantInput = this.productForm.querySelector('input[name="id"][data-product-selected-value]');
    return variantInput ? parseInt(variantInput.value) : null;
  }

  parsePrice(priceString) {
    return parseFloat(priceString.replace(/[^0-9.]/g, ''));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new AddOnProductManager();

  const pillSelector =
    '.product-form__input--checkbox fieldset.product-form__input--pill input[type="radio"], .product-form__input--checkbox fieldset.product-form__input--pill input[type="checkbox"]';

  document.addEventListener(
    'keydown',
    (event) => {
      const input = event.target.closest(pillSelector);
      if (!input) return;

      const fieldset = input.closest('fieldset.product-form__input--pill');
      const group =
        input.type === 'radio'
          ? [...fieldset.querySelectorAll(`input[type="radio"][name="${CSS.escape(input.name)}"]`)]
          : [input];
      const index = group.indexOf(input);

      const focusSibling = (nextIndex) => {
        if (index === -1 || nextIndex < 0 || nextIndex >= group.length) return false;
        event.preventDefault();
        group[nextIndex].focus();
        return true;
      };

      if (event.key === 'Tab' && input.type === 'radio') {
        focusSibling(event.shiftKey ? index - 1 : index + 1);
        return;
      }

      if (input.type === 'radio' && (event.key === 'ArrowRight' || event.key === 'ArrowDown')) {
        focusSibling(index + 1);
        return;
      }

      if (input.type === 'radio' && (event.key === 'ArrowLeft' || event.key === 'ArrowUp')) {
        focusSibling(index - 1);
        return;
      }

      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      if (input.type === 'checkbox' || !input.checked) input.click();
    },
    true
  );
});
